function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 1024 1024",
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "none",
  strokeWidth: "36",
  d: "M122.622 199.29h141.579v141.579H122.622zM712.768 203.339h141.579v141.579H712.768z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "none",
  strokeWidth: "36",
  paintOrder: "fill markers",
  d: "M397.369 457.061h141.579V598.64H397.369z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "none",
  strokeWidth: "36",
  d: "M110.006 778.065h141.579v141.579H110.006zM728.188 658.916h141.579v141.579H728.188z"
}));